import { createContext, ReactNode, useContext } from "react";
import { AxiosInstance } from "axios";

const ApiContext = createContext<AxiosInstance | null>(null);

export const ApiProvider = ({ api, children }: { api: AxiosInstance; children: ReactNode }) => <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;

export const useApi = (): AxiosInstance => {
	const api = useContext(ApiContext);
	if (api == null) {
		throw new Error("useApi must be used inside an ApiProvider");
	}
	return api;
};
